import React from "react";
import "../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import Software from "./Software";

const CallSoftwares = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <Software />
    </div>
  );
}
export default CallSoftwares;